module.exports = (__webpack_require__(50))(70);